import React from 'react';

import { Link, Prompt } from 'react-router-dom';

import { Page } from 'components/modules/AutoruLayout/Page/Page';
import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';
import { Loading } from 'components/modules/Insurance/components/Loading/Loading';
import { Button } from 'components/uikit/Button/Button';

import { FormWrapper } from '../FormWrapper/FormWrapper';
import { Stepper } from '../Stepper/Stepper';
import { PageBottom } from '../PageBottom/PageBottom';

import { AddDriverButton } from './components/AddDriverButton/AddDriverButton';
import { List } from './components/List/List';
import { MultidriveForm } from './components/MultidriveForm/MultidriveForm';
import { CONFIRM_MESSAGE } from './Drivers.constants';
import { useDriversPresenter } from './Drivers.presenter';
import * as S from './Drivers.styles';

export const Drivers = () => {
  const presenter = useDriversPresenter();

  return (
    <>
      <Page
        aside={<Stepper />}
        bottom={
          !presenter.loading && (
            <PageBottom>
              <Button as={Link} size="m" theme="3" to={presenter.previousPagePath}>
                Назад
              </Button>
              <Button
                disabled={presenter.disabled || !presenter.drivers.length}
                size="m"
                theme="1"
                onClick={presenter.onSubmit}
              >
                Продолжить
              </Button>
            </PageBottom>
          )
        }
      >
        {presenter.loading && <Loading />}
        {!presenter.loading && (
          <PageContent
            title="Список водителей КАСКО"
            header={<S.Switcher label="Совпадает со списком ОСАГО" disabled value />}
          >
            <S.Content>
              <FormWrapper>
                <S.RadioGroup value={presenter.multidrive} onChange={presenter.onChangeMultidrive}>
                  <S.Radio disabled={presenter.disabled} label="Ограниченный" value={false} />
                  <S.Radio disabled={presenter.disabled} label="Мультидрайв" value={true} />
                </S.RadioGroup>
              </FormWrapper>

              {!presenter.multidrive && <List drivers={presenter.drivers} />}
            </S.Content>
            {!presenter.multidrive && (
              <AddDriverButton position={presenter.drivers?.length ? 'left' : 'center'} />
            )}
            {presenter.multidrive && <MultidriveForm />}
          </PageContent>
        )}
      </Page>
      <Prompt when={presenter.someDriverEdit} message={CONFIRM_MESSAGE} />
    </>
  );
};
